/**
 * Mach 3 lid die-cut, traced from LDB's spec sheet (2026-08-25).
 *
 * Millimetres on the untrimmed sheet, origin top-left. Traced at ~2.228 px/mm;
 * the horizontal and vertical scales agree to 0.2 per cent, and the traced
 * sheet width comes back as 283.2 against the stated 284.5 -- half a per cent
 * -- which is the check that the trace is sound.
 *
 * NOTCH_PROFILE is the real measured edge, not an approximation of it. All four
 * notches (two per side) were traced at sub-pixel precision and normalised to
 * u = 0..1 along the notch and v = 0..1 as a fraction of its depth; they agree
 * to a mean spread of 0.076, so one canonical profile serves all four. The
 * shape flares -- roughly 70 per cent of full depth within the first fifth,
 * then easing to full depth at the midpoint -- which a rounded rectangle does
 * not reproduce.
 */
var NOTCH_PROFILE = [[0.0, 0.0478], [0.025, 0.0708], [0.05, 0.101], [0.075, 0.1431], [0.1, 0.2085], [0.125, 0.3349], [0.15, 0.4743], [0.175, 0.6279], [0.2, 0.7404], [0.225, 0.7892], [0.25, 0.8133], [0.275, 0.8368], [0.3, 0.8573], [0.325, 0.877], [0.35, 0.8964], [0.375, 0.9173], [0.4, 0.9383], [0.425, 0.9581], [0.45, 0.9781], [0.475, 0.9908], [0.5, 0.9976], [0.525, 0.9913], [0.55, 0.9759], [0.575, 0.9583], [0.6, 0.9411], [0.625, 0.922], [0.65, 0.9015], [0.675, 0.8812], [0.7, 0.8626], [0.725, 0.8427], [0.75, 0.8189], [0.775, 0.7878], [0.8, 0.7312], [0.825, 0.6279], [0.85, 0.4876], [0.875, 0.3445], [0.9, 0.2272], [0.925, 0.1292], [0.95, 0.0777], [0.975, 0.0478], [1.0, 0.0261]];

var LID_SPEC = {
  w: 284.5,
  h: 152.4,
  panels: [87.5, 109.5, 87.5],   // creases fall at 87.5 and 197.0
  bleed: 7.6,
  crease: 3.2,
  corner: 2.7,
  stitchInset: 2.0,              // stitching sits 2mm inside the trimmed edge
  notches: [
    { top: 8.54, bottom: 39.11, depth: 20.78 },
    { top: 81.82, bottom: 111.72, depth: 20.48 }
  ]
};

/**
 * Die-cut outline as path ops, so one geometry drives the 2D canvas, an SVG
 * path and a THREE.Shape without being written three times and drifting apart.
 * Walks clockwise from the top-left corner.
 */
function lidOutline(spec) {
  var s = spec || LID_SPEC;
  var W = s.w, H = s.h, r = s.corner;
  var ops = [];
  function M(x, y) { ops.push(['M', x, y]); }
  function L(x, y) { ops.push(['L', x, y]); }
  function Q(cx, cy, x, y) { ops.push(['Q', cx, cy, x, y]); }

  // side: +1 = right edge (cut runs toward -x), -1 = left edge (toward +x)
  function notchPts(n, side, downward) {
    var pts = [];
    for (var i = 0; i < NOTCH_PROFILE.length; i++) {
      var p = NOTCH_PROFILE[downward ? i : NOTCH_PROFILE.length - 1 - i];
      var y = n.top + (n.bottom - n.top) * p[0];
      var x = side > 0 ? W - n.depth * p[1] : n.depth * p[1];
      pts.push([x, y]);
    }
    return pts;
  }

  M(r, 0);
  L(W - r, 0);
  Q(W, 0, W, r);

  var down = s.notches.slice().sort(function (a, b) { return a.top - b.top; });
  for (var i = 0; i < down.length; i++) {
    var pts = notchPts(down[i], 1, true);
    for (var k = 0; k < pts.length; k++) L(pts[k][0], pts[k][1]);
  }
  L(W, H - r);
  Q(W, H, W - r, H);

  L(r, H);
  Q(0, H, 0, H - r);

  var up = s.notches.slice().sort(function (a, b) { return b.top - a.top; });
  for (var j = 0; j < up.length; j++) {
    var p2 = notchPts(up[j], -1, false);
    for (var m = 0; m < p2.length; m++) L(p2[m][0], p2[m][1]);
  }
  L(0, r);
  Q(0, 0, r, 0);
  return ops;
}

/** Crease centre-lines, cumulative from the left edge. */
function lidCreases(spec) {
  var s = spec || LID_SPEC, xs = [], acc = 0;
  for (var i = 0; i < s.panels.length - 1; i++) { acc += s.panels[i]; xs.push(acc); }
  return xs;
}

if (typeof module !== 'undefined') {
  module.exports = { LID_SPEC: LID_SPEC, NOTCH_PROFILE: NOTCH_PROFILE, lidOutline: lidOutline, lidCreases: lidCreases };
}
